const i18n = {
  'en-US': {
    'navbar.logout': 'Logout',
    'menu.user.setting': 'Setting',
    'menu.welcome': 'Welcome',
    'menu.business': "Business",
    'menu.business.list': 'Business List',
    'menu.business.package.list': 'Package List',
    'menu.business.package.create': 'Create Package',
    'menu.tenant': "Tenant",
    'menu.tenant.list': 'Tenant List',
    'menu.tenant.create': 'Create Tenant',
    'menu.tenant.package.list': 'Tenant Package',
    'menu.tenant.user.list': 'User List',
    'menu.system': 'System Setting',
    'menu.system.menu': 'Menu',
    'menu.system.role': 'Role',
    'menu.system.user': 'User',
    'menu.system.permission': 'Permission',
    'menu.system.dictionary': 'Dictionary'
  },
  'zh-CN': {
    'navbar.logout': '退出登录',
    'menu.welcome': '欢迎',
    'menu.user.setting': "个人设置",
    'menu.business': "业务",
    'menu.business.list': "业务列表",
    'menu.business.package.list': "套餐列表",
    'menu.business.package.create': "创建套餐",
    'menu.tenant': "租户",
    'menu.tenant.list': "租户列表",
    'menu.tenant.create': "创建租户",
    'menu.tenant.package.list': "租户套餐",
    'menu.tenant.user.list': "用户列表",
    'menu.system': "系统设置",
    'menu.system.menu': "菜单",
    'menu.system.role': "角色",
    'menu.system.user': "用户",
    'menu.system.permission': "权限",
    'menu.system.dictionary': "字典"
  }
};
export default i18n;